/**
 * TrXL Shop - Werbe-Attribution (gclid / UTM)
 *
 * - localStorage 'trxl_attribution' (90 Tage): erster bekannter Ads-Touch
 *   (fuer "assistierten" Umsatz: Kunde war irgendwann ueber Google Ads da).
 * - sessionStorage 'trxl_session': Quelle der AKTUELLEN Sitzung (Landing der
 *   Sitzung). Daraus laesst sich erkennen, ob die KONVERTIERENDE Sitzung selbst
 *   google/cpc war ("direkter" Google-Ads-Umsatz) oder ein anderer Kanal.
 */

const KEY = 'trxl_attribution';
const SKEY = 'trxl_session';
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;

const PARAM_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium',
  'utm_campaign', 'utm_term', 'utm_content', 'trxl_adgroup_id', 'trxl_ad_id'];

const PAID_MEDIA = ['cpc', 'ppc', 'paid', 'paidsearch', 'paid_search'];

/** Erfasst die Quelle der aktuellen Sitzung einmalig (Landing der Sitzung). */
function captureSession(params) {
  try {
    if (sessionStorage.getItem(SKEY)) return; // Sitzung bereits erfasst
    const gclid = params.get('gclid') || params.get('gbraid') || params.get('wbraid') || '';
    const src = (params.get('utm_source') || '').toLowerCase();
    const med = (params.get('utm_medium') || '').toLowerCase();
    let session;
    if (gclid || PAID_MEDIA.includes(med)) {
      session = { source: src || 'google', medium: med || 'cpc', gclid };
    } else if (src || med) {
      session = { source: src, medium: med, gclid: '' };
    } else {
      const ref = document.referrer || '';
      session = ref ? { source: 'referral', medium: 'referral', gclid: '' }
                    : { source: '(direct)', medium: '(none)', gclid: '' };
    }
    session.session_started_at = new Date().toISOString();
    sessionStorage.setItem(SKEY, JSON.stringify(session));
  } catch {
    /* ignore */
  }
}

export function captureAttribution() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    captureSession(params);

    const found = {};
    PARAM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 300);
    });
    if (Object.keys(found).length === 0) return; // kein neuer Ads-Touch

    const data = {
      ...found,
      landing_page: (window.location.pathname || '').slice(0, 300),
      referrer: (document.referrer || '').slice(0, 300),
      captured_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

/** Liefert First-Touch-Attribution + Quelle der konvertierenden Sitzung. */
export function getAttribution() {
  if (typeof window === 'undefined') return {};
  let data = {};
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.captured_at && (Date.now() - new Date(parsed.captured_at).getTime()) > MAX_AGE_MS) {
        localStorage.removeItem(KEY);
      } else {
        data = parsed || {};
      }
    }
  } catch {
    /* ignore */
  }
  try {
    const s = JSON.parse(sessionStorage.getItem(SKEY) || '{}');
    if (s.source) {
      data = {
        ...data,
        session_source: s.source,
        session_medium: s.medium || '',
        session_gclid: s.gclid || '',
      };
    }
  } catch {
    /* ignore */
  }
  return data;
}
